import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import NewsFeed from './components/NewsFeed';
import Gallery from './components/Gallery';
import FeatureGrid from './components/FeatureGrid';
import About from './components/About';
import FaqSection from './components/FaqSection';
import Testimonials from './components/Testimonials';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!show) return null;
  return (
    <a
      href="#home"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg shadow-primary-500/20 transition-transform hover:-translate-y-1 hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line h-5 w-5" />
    </a>
  );
}

const siteJson = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '吃瓜今日',
  alternateName: '吃瓜今日早报',
  url: '/',
  description: '吃瓜今日早报，每日清晨更新的晨间瓜速递，覆盖影视、综艺、音乐、饭圈、时尚等头条瓜与首发猛料。',
  inLanguage: 'zh-CN',
};

const orgJson = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '吃瓜今日',
  url: '/',
  slogan: '晨间瓜速递 · 一早就到的瓜',
  email: 'hello@chiguajinri.cn',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(siteJson)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJson)}</script>
      <Navbar />
      <main>
        <Hero />
        <NewsFeed />
        <Gallery />
        <FeatureGrid />
        <About />
        <FaqSection />
        <Testimonials />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}